import React from 'react';
import { motion } from 'framer-motion';
const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
// April 2026 starts on Wednesday (index 2 in Mon-Sun array)
const startOffset = 2;
const daysInMonth = 30;
// Generate mock data
const generateMockData = () => {
  const data = [];
  let winDays = 0;
  let totalPnl = 0;
  for (let i = 1; i <= daysInMonth; i++) {
    const dayOfWeek = (startOffset + i - 1) % 7;
    const isWeekend = dayOfWeek === 5 || dayOfWeek === 6; // Sat or Sun
    if (isWeekend) {
      data.push({
        day: i,
        pnl: 0,
        isTradeDay: false
      });
    } else {
      // 65% win rate
      const isWin = Math.random() < 0.65;
      const amount = isWin ? Math.floor(Math.random() * 300) + 50 : -(Math.floor(Math.random() * 200) + 50);
      if (isWin) winDays++;
      totalPnl += amount;
      data.push({
        day: i,
        pnl: amount,
        isTradeDay: true
      });
    }
  }
  return {
    data,
    winDays,
    totalPnl: 1247.32,
    totalTradeDays: 21
  }; // Hardcode totals to match prompt
};
const {
  data: calendarData
} = generateMockData();
export function PnLCalendar() {
  return <div className="glass-border rounded-[20px] p-6" data-id="element-107">
      <div className="mb-6" data-id="element-108">
        <h3 className="text-sm font-heading text-text-primary" data-id="element-109">
          Monthly P&L Calendar
        </h3>
        <p className="text-xs text-text-secondary mt-1" data-id="element-110">April 2026</p>
      </div>

      <div className="grid grid-cols-7 gap-2 mb-4" data-id="element-111">
        {daysOfWeek.map(day => <div key={day} className="text-center text-[10px] font-label text-text-secondary uppercase" data-id="element-112">
            {day}
          </div>)}
      </div>

      <div className="grid grid-cols-7 gap-2" data-id="element-113">
        {Array.from({
        length: startOffset
      }).map((_, i) => <div key={`empty-${i}`} className="h-20 rounded-xl bg-background-elevated/30" data-id="element-114" />)}

        {calendarData.map((dayData, i) => {
        const isProfit = dayData.pnl > 0;
        const isLoss = dayData.pnl < 0;
        let bgColor = 'bg-background-elevated/50';
        if (isProfit) bgColor = 'bg-success/5 border border-success/10';else if (isLoss) bgColor = 'bg-danger/5 border border-danger/10';
        return <motion.div key={dayData.day} initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.2,
          delay: i * 0.01
        }} className={`h-20 rounded-xl p-2 flex flex-col ${bgColor}`} data-id="element-115">
              <span className="text-[10px] font-numbers text-text-secondary" data-id="element-116">
                {dayData.day}
              </span>
              <div className="flex-1 flex items-center justify-center" data-id="element-117">
                {dayData.isTradeDay && <span className={`text-sm font-numbers ${isProfit ? 'text-success' : isLoss ? 'text-danger' : 'text-text-secondary'}`} data-id="element-118">
                    {dayData.pnl > 0 ? '+' : ''}
                    {dayData.pnl === 0 ? '-' : `$${Math.abs(dayData.pnl)}`}
                  </span>}
              </div>
            </motion.div>;
      })}
      </div>

      <div className="mt-6 pt-4 border-t border-border-subtle flex items-center justify-between" data-id="element-119">
        <div className="text-sm font-medium text-text-primary" data-id="element-120">
          Monthly Total:{' '}
          <span className="text-success font-numbers" data-id="element-121">+$1,247.32</span>
        </div>
        <div className="text-sm text-text-secondary" data-id="element-122">
          Win Days:{' '}
          <span className="text-text-primary font-numbers" data-id="element-123">14/21</span>
        </div>
      </div>
    </div>;
}